/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { AccountBlockList, AccountCancelBlackList } from '../modals';
import { useHistory } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { NoteAdd, ListAlt, HighlightOff, UploadFile, Download } from "@mui/icons-material";
import { Card, CardHeader, Grid, IconButton, Tooltip, Typography, Button, TextField, MenuItem } from "@mui/material";
import { theme, customStyles2, useStyles } from "../../util/TableStyles"
import { typeValue, severity, noDataComponent } from "../../util/DataObject"
import { openlightbox } from '../../util/Functions';
import ListDetail from "../elements/ListsDetail"
import DataTable from "react-data-table-component";
import moment from "moment";
import "moment/locale/es";
import { WidgetStyle } from "../../util/Styles";
import BlockListError from "../modals/BlockListError";

const BlackWhiteList = (props) => {
  moment.locale("es");
  const history = useHistory();
  const [data, setData] = useState([]);
  const [oldData, setOldData] = useState([]);
  const [type, setType] = useState("");
  const [search, setSearch] = useState({ value: "", type: "" });
  const clasess = useStyles();
  const status = [
    { value: "enabled", label: "Activo" },
    { value: "disabled", label: "Inactivo" },
  ];
  
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [totalPage, setTotalPage] = useState(50);

  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    setData(props.content)
    setOldData(props.content)
    setType(props.widgets[0].typeList)
    setTotal(props.widgets[0].pagination.total_documents);
    setPage(props.widgets[0].pagination.current_page);
    setPages(props.widgets[0].pagination.total_pages);
  };

  const hasAction = (action) => {
    return props.widgets[0].config?.actions?.indexOf(action) > -1;
  };

  // CRUD ---------------------------------
  const register = async (item) => {
    props.changeLoader(true);

    let data = {};
    if (item) {
      data['items'] = item;
      data["typeList"] = type;
    }

    const as = <AccountBlockList
      catalogs={props.catalogs}
      pos={props.pos}
      changeAlert={props.changeAlert}
      changeLoader={props.changeLoader}
      contentModal={data}
      typeList={type}
      reload={filterType}
      key="accountBlockList"
    />
    openlightbox(as);
    props.changeLoader(false);
  }

  const listBlock = async (item) => {
    props.changeLoader(true);
		let user = JSON.parse(localStorage.session);
		let data = item;
		data["user"] = user["name"];
    data["status"] = "disabled"
   
    if(type){
      data["typeList"] = type
      setType(type)
    }

    const as = <AccountCancelBlackList
      catalogs={props.catalogs}
      pos={props.pos}
      changeAlert={props.changeAlert}
      changeLoader={props.changeLoader}
      contentModal={data}
      typeList={type}
      reload={filterType}
      key="accountCancelBlackList"
    />
    openlightbox(as);
    props.changeLoader(false);
	};

  // Functions ------------------------------
  const filterType = async (e) => {
    props.changeLoader(true);

    let data;
    if(e?.target?.value){
      setType(e?.target?.value)
      data = {
        typeList: e?.target?.value,  
        page_number: 1,
        results_per_page: 50
      }
    } else {
      setType(type)
      data = {
        typeList: type,  
        page_number: 1,
        results_per_page: 50      
      }
      if(search.value){
        data["value"] = search.value
      }
      if(search['name']){
        data["value"] = search['name']
      }
      if(search['type']){
        data['type'] = search.type
      }
    }

    let request = await API.service('blackWhiteList', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200) {
      if (request.data.data.response == 'OK') {
        setData(request.data.data.widget[0].content)
        setOldData(request.data.data.widget[0].content)
        setSearch({value: "", type: ""})
        setTotal(request.data.data.widget[0].pagination.total_documents);
        setPage(request.data.data.widget[0].pagination.current_page);
        setPages(request.data.data.widget[0].pagination.total_pages);
      }
    }
    props.changeLoader(false);
  }

  const changePage = async (execute) => {
    props.changeLoader(true);
    let dataRequest = {
      typeList: type,
      page_number: page,
      results_per_page: totalPage,
    };

    if (execute == "next") {
      dataRequest.page_number = page + 1;
    }
    if (execute == "prev") {
      dataRequest.page_number = page - 1;
    }

    let request = await API.service('blackWhiteList', dataRequest, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200) {
      if (request.data.data.response == 'OK') {
        let res = request.data.data.widget[0]
        setTotal(res.pagination.total_documents);
        setPage(res.pagination.current_page);
        setPages(res.pagination.total_pages);
        setData(res.content)
        setOldData(res.content)
      }
    }
    props.changeLoader(false);
  };
  
  const handleSearch = async (key, key2, e) => {
    let s = search
    
    if(key === "name"){
      s[key] = {
        ...s[key],
        [key2]: key2 === "bdate" ? new Date(e.target.value).toJSON() : e.target.value.trim()
      }
    } else if(e.target.value === "all") {
      await filterType(type)
    } else {
      s[key] = e.target.value
    }

    setSearch(JSON.parse(JSON.stringify(s)));    
  }

  // DataTable -----------------------------------
  const columns = [];
  if(data){
    columns.push(
      { selector: (row) => moment(row.cdate).format("L"), name: "Fecha", width: "11%", wrap: true, sortable: true },
      { selector: (row) => typeValue.map((i) => {if(i.value === row.type){return i.label}}), name: "Tipo", width:"10%", wrap: true, sortable: true },
      { selector: (row) => row.user, name: "Usuario", width:"19%", wrap: true, sortable: true },
      { selector: (row) => row.uuid , name: "UUID", width: type !== "black" ? "18%": "27%", wrap: true, sortable: true },
    )
    columns.push(
      { selector: (row) => status.map((i) => {if(i.value === row.status){return i.label}}),  name: "Estatus", width:"10%", wrap: true, sortable: true },
      { selector: (row) => row.severity ? severity.map((i) => { if(i.key ===  row.severity){return i.label}}) : "N/A", name: "Severidad", width:"10%", wrap: true, sortable: true },
      { cell: (row) => {
        return (
          <IconButton title="Cancelar Registro" className={clasess.buttonAdd} onClick={() => listBlock(row)} disabled={row.status == "disabled" ? true : false}>
            <HighlightOff />
          </IconButton>
        )},
       width:"7%", wrap: true, sortable: true
      },
    )   
  }

  const viewInfo = (item) => {
    return (
      <div className="select_info" style={{paddingBottom: "15px"}}>
        <ListDetail
          typeList={type}
          detail={item.data}
          states={props.catalogs.states}
          countries={props.catalogs.country}
        />
      </div>
    );
  };

  // Download Report ------------------------------------
  const download = async () => {
    props.changeLoader(true);    
    
    let request = await API.service( "downloadReport", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      if (request.data.data.content) {
        let url = request.data.data.content;
        window.open(url, "_blank");

        props.changeLoader(false);
        props.changeAlert(true, "success", "Reporte descargado con éxito");
        return;
      }
    } else {
      props.changeLoader(false);
      props.changeAlert(true, "error", "Error en descarga de reporte");
    }
  };

  const onFileLoad = async (e, file) => {
    let csv = e.target.files[0];
    if(!csv){
      props.changeAlert(true, 'error', "Error en selección de archivo");
    } else if(csv.type !== "text/csv"){
      props.changeAlert(true, 'error', "Error: El tipo de archivo permitido es CSV");
    } else {
        let reader = new FileReader();
        if(csv){
          reader.readAsDataURL(csv);
          reader.onload = await ((binding) => {
              return async () => {
                props.changeLoader(true);
                let parts = reader.result.toString().split(',');
                let response = await API.service('multipleBlackList', {file: parts[1]}, props.pos, props.changeAlert, props.changeLoader, history);

                const file = document.getElementById('file');
                file["value"] = '';

                if(response.data.data.content.error){
                  const as = <BlockListError content={response.data.data.content.data}/>
                  openlightbox(as);
                } else {
                  register(response.data.data.content)
                }
                props.changeLoader(false);
              }}
          )(this);
        }
    }
  }

  const addFile = () => {
    document.getElementById('file').click();
  }

  return (
    <WidgetStyle property={String(false)}>
      <ThemeProvider theme={theme}>
        <Grid container>
          <Card sx={{width: '100% !important', padding: 3}}>
            <CardHeader
              sx={{marginBottom: 2}}
              title={
                <div style={{display: 'inline-flex'}}>
                  <ListAlt/>
                  <Typography
                    component={'h3'} 
                    fontFamily="Muli,sans-serif"
                    fontSize="20px"
                    fontWeight={600}
                    sx={{color: '#3E3E42', padding: "0 14px"}}
                    >
                      Listas negras
                  </Typography>
                </div>
              }
              action={
                <div style={{paddingRight: 0}}>
                  {
                    hasAction("download") &&
                    <Tooltip title='Descargar'>
                      <IconButton onClick={download}>
                        <Download/>
                      </IconButton>
                    </Tooltip>
                  }
                  <Tooltip title={"Agregar Registro"}>
                    <IconButton onClick={register.bind(this, "")} >
                      <NoteAdd />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={'Carga multiple'}>
                    <IconButton onClick={addFile.bind(this, "")} >
                      <UploadFile />
                    </IconButton>
                  </Tooltip>
                  <input type="file" accept="text/csv" style={{display: 'none'}} id="file" onChange={onFileLoad.bind(this)} />
                </div>
              }
              />
            
              <Grid container spacing={2} justifyContent="right" width={"inherit"}>
                {search.type === "name" &&
                  <>
                    <Grid item xs={2}>
                      <TextField
                        label="Nombre" value={search.value["gname"]} onChange={handleSearch.bind(this, "name", "gname")} size="small" fullWidth
                        />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Apellido Paterno" value={search.value["lname"]} onChange={handleSearch.bind(this, "name", "lname")} size="small" fullWidth
                        />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Apellido Materno" value={search.value["sname"]} onChange={handleSearch.bind(this, "name", "sname")} size="small" fullWidth
                        />
                    </Grid>
                  </>
                }
                {search.type === "business_name" &&
                  <>
                    <Grid item xs={3}>
                      <TextField
                        label="Nombre" value={search.value["corporate_name"]} onChange={handleSearch.bind(this, "name", "corporate_name")} size="small" fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        type="date" label="Fecha de constitución" value={search.value["bdate"]} onChange={handleSearch.bind(this, "name", "bdate")} size="small" fullWidth InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                  </>
                }
                {search.type !== "name" && search.type !== "business_name" &&
                  <Grid item xs={4}>
                    <TextField
                      label="Buscar registro" value={search.value} onChange={handleSearch.bind(this, "value", "")} size="small" fullWidth
                    />
                  </Grid>
                }
                <Grid item xs={2}>
                  <TextField label="Tipo de Dato" value={search.type} onChange={handleSearch.bind(this, "type", "")} select size="small" fullWidth >
                    {typeValue.map((p) => (
                      p.value !== "address" && <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
                    ))}
                    <MenuItem value={"all"}>Todo</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={1}>
                  <Button variant="contained" onClick={filterType.bind(this)} >Buscar</Button> 
                </Grid>
              </Grid>
      
              {/* Paginacion -----------------------------------> */}
              <div className={clasess.selectOption} style={{ marginTop: "40px" }}>
                <span className="neutral">
                  {page === 1 ? 0 : (page - 1) * totalPage + 1} -{" "}
                  {totalPage * page >= total ? total : totalPage * page} de {total}
                </span>
                {page > 1 && (
                  <i className="tap ibon-chevron-left indigo" onClick={changePage.bind(this, "prev")} ></i>
                  )}
                {page < pages && (
                  <i className="tap ibon-chevron-right indigo" onClick={changePage.bind(this, "next")}></i>
                  )}
              </div>
            
              <div style={{ width: "100%", margin: "auto" }}>        
                <DataTable
                  columns={columns}
                  data={data}
                  expandableRows={true}
                  expandOnRowClicked={false}
                  expandableRowsComponent={viewInfo}             
                  customStyles={customStyles2}
                  noDataComponent={noDataComponent}
                  />    
              </div>
          </Card>
        </Grid>
      </ThemeProvider>
    </WidgetStyle>
  );
};

export default BlackWhiteList;
